import React, { useEffect, useRef, useState } from "react";

export default function MobilePdfPage({ page, capture, loadingLabel, errorLabel, pageLabel, fallbackLabel, onDownload }: {
  page: HTMLElement | null; capture: (page: HTMLElement, signal?: AbortSignal) => Promise<HTMLCanvasElement>;
  loadingLabel: string; errorLabel: string; pageLabel: string; fallbackLabel: string; onDownload: () => void;
}) {
  const loadTimer = useRef<number>();
  const [image, setImage] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    let url = "";
    setImage(""); setFailed(false); setLoaded(false);
    const timer = window.setTimeout(() => { if (active) setFailed(true); }, 20000);
    loadTimer.current = timer;
    if (page) capture(page, controller.signal).then(canvas => {
      if (!active) { canvas.width = 0; canvas.height = 0; return; }
      canvas.toBlob(blob => {
        canvas.width = 0; canvas.height = 0;
        if (!active) return;
        if (!blob) { setFailed(true); return; }
        url = URL.createObjectURL(blob);
        setImage(url);
      }, "image/png");
    }).catch(() => { if (active) setFailed(true); });
    return () => { active = false; controller.abort(); clearTimeout(timer); if (url) URL.revokeObjectURL(url); };
    // Capture uses the same fixed-width document pages as export. A new page owns its URL.
  }, [page, capture]);
  return <div className="pdf-mobile-page">
    {!loaded && !failed && <p role="status">{loadingLabel}</p>}
    {failed && <div role="alert"><p>{errorLabel}</p><button type="button" className="pdf-preview-action" onClick={onDownload}>{fallbackLabel}</button></div>}
    {image && <img src={image} alt={pageLabel} onLoad={() => { clearTimeout(loadTimer.current); setLoaded(true); setFailed(false); }} onError={() => setFailed(true)} />}
  </div>;
}
